<template>
    <div ref="container" class="absolute right-0 top-16 flex flex-col gap-2 pt-4">
        <toast
            v-for="toast in toasts"
            :key="toast.id"
            :content="toast.content"
            :is_notification="toast.is_notification"
            ref="toastRefs"
            @closed="removeToast(toast.id)"
        ></toast>
    </div>
</template>

<script lang="ts" setup>
import Toast from './toast.vue'

const container = ref<HTMLElement>()
const toastRefs = ref<Array<{ close: () => void }>>([])

const toasts = ref<Array<{ id: number, content: INotification, is_notification: boolean }>>([])
const notificationStore = useNotificationStore()
const displayedNotifications = new WeakSet<INotification>()
let nextToastId = 0

const newToast = (content: INotification, is_notification: boolean) => {
    toasts.value.push({ id: nextToastId++, content, is_notification })
}

const removeToast = (id: number) => {
    toasts.value = toasts.value.filter(toast => toast.id !== id)
}

const hideAll = () => {
    toastRefs.value.forEach(toast => toast.close())
}

watch(() => notificationStore.notifications, async notifications => {
    for (const notification of notifications) {
        if (displayedNotifications.has(notification)) continue
        displayedNotifications.add(notification)
        newToast(notification, true)
        if (notification.is_temp) await useNotifications().remove_notification(notification)
    }
}, { deep: true })


defineExpose({
    newToast,
    hideAll
})
</script>
